module.exports = __webpack_public_path__ + "static/media/culinarioo.904afba2.svg";